import { useEffect, useState } from "react";
import { api, API } from "../lib/api";

let _cache; // undefined = not loaded; string = logo_url ("" means default)
let _pending;
const abs = (u) => (u && u.startsWith("/api/") ? `${API}${u.replace(/^\/api/, "")}` : u);

/** Atualiza o logo em todas as telas abertas logo após salvar no Admin. */
export function setSiteLogo(url) {
  _cache = url || "";
  _pending = Promise.resolve(_cache);
  window.dispatchEvent(new CustomEvent("lgfx:logo", { detail: _cache }));
}

export function SiteLogo({ className = "" }) {
  const [url, setUrl] = useState(_cache);
  useEffect(() => {
    const on = (e) => setUrl(e.detail);
    window.addEventListener("lgfx:logo", on);
    return () => window.removeEventListener("lgfx:logo", on);
  }, []);
  useEffect(() => {
    let alive = true;
    if (_cache !== undefined) { setUrl(_cache); return; }
    if (!_pending) _pending = api.get("/site/branding").then(({ data }) => { _cache = data.logo_url || ""; return _cache; }).catch(() => { _cache = ""; return ""; });
    _pending.then((u) => { if (alive) setUrl(u); });
    return () => { alive = false; };
  }, []);
  const src = url ? abs(url) : "/logo-full.png";
  return <img src={src} alt="LiveGrafX" className={`object-contain shrink-0 ${className}`} />;
}
